export default $axios => ({
  sync() {
    return $axios.get('/admin/v1/settings/calendar/sync');
  },

  callback(payload) {
    return $axios.get('/admin/v1/settings/calendar/oauth2callback', {
      params: {
        code: payload.code || null,
      }
    });
  },
  
  checkTokenIsValid() {
    return $axios.get('/admin/v1/settings/calendar/token-is-valid');
  }
});
